// auth.js
export const setAuthTokens = (tokens) => {
  localStorage.setItem("accessToken", tokens.access_token);
  localStorage.setItem("refreshToken", tokens.refresh_token);
  localStorage.setItem("userId", tokens.user_id);
};

export const getAccessToken = () => localStorage.getItem("accessToken");
export const clearAuthTokens = () => localStorage.clear();
